import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "80%",
    height: "83vh",
    margin: "0 auto",
  },
  titleArea: {
    marginBottom: 5,
  },
  title: {
    fontSize: 30,
  },
  form: {
    width: "70%",
    margin: "0 auto"
  },
  stack: {
    width: "50%",
  },
  listTitle: {
    fontSize: 20,
    marginTop: 4,
    marginBottom: 2,
    minWidth: "20%",
  },
  autocompleteArea: {
    width: "75%",
  },
  buttonArea: {
    width: "30%",
    margin: "0 auto",
    marginTop: 5,
    justifyContent: "space-between",
  },
  chipsbox: {
    marginTop: 2
  },
  chips: {
    marginRight: "8px",
    marginBottom: "8px",
    background: "#e0e0e0",
  },
};
